<template>
  <div class="nickname-change-wrapper" @click="closeWrapper" ref="NicknameChangeWrapper">
    <div :class="{'nickname-change-box': true, closeAnimation}">

      <div class="top-row">
        <div class="title">Change Nickname</div>
        <div class="close">
          <font-awesome-icon icon="times" class="icon" @click="close"/>
        </div>
      </div>

      <div class="loading-row" v-if="loading">
        <Loader/>
      </div>

      <div class="bottom-row" v-if="!loading">

        <div class="input-row">
          <div class="input-box">
            <div class="frame">
              <div class="name" :class="{ name_error: nicknameError }">
                <span class="label">Nickname</span>
                <span class="error">{{ nicknameError  }}</span>
              </div>
              <div class="input">
                <input type="text" v-model="nickname" :class="{ input_error: nicknameError  }" @input="nicknameError = null" @keydown.enter="onChange">
              </div>
            </div>
          </div>
        </div>

        <div class="button-row">
          <div class="frame">
            <button @click="onChange" :class="{'inactive': nicknameError}">Change</button>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios';
import alert from '@/lib/alert';
import Loader from '@/components/Loader'

export default {
  name: 'NicknameChangeWrapper',
  props: {
    nick: String
  },
  data() {
    return {
      loading: false,
      closeAnimation: false,
      nickname: '',
      nicknameError: null
    }
  },
  components: {
    Loader
  },
  methods: {
    closeWrapper(event) {
      if(event.target == this.$refs.NicknameChangeWrapper) {
        this.close();
      }
    },
    close() {
      this.closeAnimation = true;
      setTimeout(() => {
        this.$emit('close');
      }, 300);
    },
    onChange() {
      if(this.nickname.trim() == '') {
        this.nicknameError = 'cannot be empty';
      } else {
        this.submit();
      }
    },
    submit() {
      this.loading = true;
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_SERVER_URL}changeUserNick`,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token') 
        },
        data: {
          nick: this.nickname
        }
      }).then(() => {
        this.loading = false;
        alert.showSuccess('Nick Changed', 2000);
        this.closeAnimation = true;
        setTimeout(() => {
          this.$emit('onNewNickname', this.nickname);
        }, 300);
      }).catch(err => {
        this.loading = false;
        console.log(err);
        alert.showError('Nick Change Error', 2000);
      })
    }
  },
  created() {
    this.nickname = this.nick;
  }
}
</script>

<style lang="scss" scoped>
  .nickname-change-wrapper {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background-color: #2526295b;
    z-index: 90;
    display: flex;
    justify-content: center;
    align-items: center;

    .nickname-change-box {
      z-index: 100;
      width: 30rem;
      height: auto;
      background-color: whitesmoke;
      border-radius: 0.2rem;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      animation: open 0.5s forwards;

      @media (max-width: 600px) {
        width: 90vw;
        height: auto;
        position: absolute;
        top: 10rem;
      }

      @keyframes open {
        0% {
          opacity: 0;
          transform: translateY(5rem);
        }
        100% {
          opacity: 1;
          transform: translateY(0rem);
        }
      }
    }

    .closeAnimation {
      animation: close 0.5s forwards;

      @keyframes close {
        0% {
          opacity: 1;
          transform: translateY(0rem);
        }
        100% {
          opacity: 0;
          transform: translateY(-5rem);
        }
      }
    }

    .top-row {
      width: 100%;
      height: 5rem;
      background-color: #11b6a5;
      display: flex;
      flex-direction: row;

      .title {
        flex: auto;
        height: 100%;
        display: flex;
        align-items: center;
        color: white;
        font-size: 1.5rem;
        padding-left: 2rem;
      }

      .close {
        width: 5rem;
        height: 5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        font-size: 1.2rem;

        .icon {
          transition: 0.2s;

          &:hover {
            opacity: 0.8;
            cursor: pointer;
          }
        }
      }
    }

    .loading-row {
      width: 100%;
      height: 12rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .bottom-row {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      @media (max-width: 600px) {
        height: auto;
      }
      padding-top: 2rem;
      padding-bottom: 1rem;

      .input-row {
        width: 100%;
        height: auto;
      }

      .button-row {
        width: 100%;
        height: 3rem;
        margin-top: 1rem;
        display: flex;
        align-items: center;
        justify-content: center;

        .frame {
          width: 18rem;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-end;
        }

        .inactive {
          filter: saturate(0);
          &:hover {
            background-color: #11b6a5;
            cursor: unset;
          }
        }

        button {
          width: auto;
          padding-left: 0.6rem;
          padding-right: 0.6rem;
          height: 2rem;
          background-color: #11b6a5;
          color: white;
          border: none;
          outline: none;
          border-radius: 0.2rem;
          font-size: 1.1rem;
          font-weight: bold;
          transition: 0.2s;

          &:hover {
            cursor: pointer;
            background-color: #10a899;
          }
        }
      }

      .input-box {
        width: 100%;
        height: 5rem;
        display: flex;
        justify-content: center;
        align-items: center;

        .frame {
          width: 18rem;
          height: 100%;
          display: flex;
          flex-direction: column;
        }

        .info {
          margin-left: 0.5rem;
          font-size: 0.9rem;
          cursor: pointer;
          position: relative;
          transition: 0.2s;

          &:hover {
            color: #e6c17d;
          }

          .info_box {
            bottom: 1.1rem;
            left: 0.8rem;
            position: absolute;
            width: 10rem;
            height: 10rem;
            z-index: 10;
            background-color: #e6c17d;
            border-radius: 1rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            visibility: hidden;
            border: 1px solid #c29e5b;
            color: rgb(37, 38, 41);

            .label {
              margin-top: 0.5rem;
              margin-bottom: 0.1rem;
            }

            .req {
              width: 100%;
              padding-left: 0.8rem;
            }
          }

          &:hover .info_box {
            visibility: visible;
          }
        }
        
        .name {
          width: 100%;
          height: 2rem;
          display: flex;
          align-items: center;
          font-size: 1.1rem;
          color: rgb(172, 169, 169);

          .label {
            font-weight: bold;
          }

          .error {
            margin-left: 0.5rem;
            font-style: italic;
          }
        }

        .name_error {
          color: rgb(239, 70, 70);
        }

        .input_error {
          border-color: rgb(239, 70, 70) !important;
        }

        .input {
          width: 100%;
          flex: auto;
          display: flex;

          input {
            width: 100%;
            height: 2rem;
            background: none;
            border: none;
            outline: none;
            background-color: rgb(226, 225, 225);
            font-size: 1rem;
            color: rgb(37, 38, 41);
            transition: 0.2s;
            border: 1px rgb(202, 201, 201) solid;
            border-radius: 0.1rem;
            padding-left: 0.5rem;
            padding-right: 0.5rem;

            @media (max-width: 600px) {
              height: 2.5rem;
            }
          }

          input:focus {
            border-color: #11b6a5;
          }
        }
      }
    }
  }  
</style>